var _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    id: "image",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    transform: "translate(5 -1031.863)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.045,
    cy: 28.409,
    r: 12.5,
    fill: "#50b748",
    fillRule: "evenodd",
    transform: "translate(-30.527 1015.318)scale(1.04)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#10a711",
    d: "M11.951 25.951a13 13 0 0 0 .13.016A13 13 0 0 0 13 26a13 13 0 0 0 1.297-.064 13 13 0 0 0 1.285-.196 13 13 0 0 0 1.26-.32 13 13 0 0 0 1.22-.445 13 13 0 0 0 1.17-.567 13 13 0 0 0 1.108-.68 13 13 0 0 0 1.035-.785 13 13 0 0 0 .951-.886 13 13 0 0 0 .858-.977 13 13 0 0 0 .755-1.057 13 13 0 0 0 .647-1.127 13 13 0 0 0 .531-1.185 13 13 0 0 0 .408-1.234 13 13 0 0 0 .286-1.268 13 13 0 0 0 .156-1.29A13 13 0 0 0 26 13a13 13 0 0 0-.053-1.053L21 7H5v12l6.951 6.951z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    transform: "translate(-5 1031.863)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2v12h16V2H0Zm1 1h14v10H1V3Zm1 1v8h12V4H2Zm1 1h10v4.361l-2.51-2.007-2.398 2.03-2.028-2.027L3 9.398V5Zm5.5 1a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5ZM5.936 8.645 8.293 11H3v-.398l.277-.186 2.659-1.771Zm4.574.003 2.178 1.743.312.25V11H9.5v-.5h-.293l-.404-.404 1.707-1.448z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    transform: "translate(0 1036.863)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.c9f7e8613a80cd35a58a8c192de58afa.svg";
export { ForwardRef as ReactComponent };